import React from 'react';
import stylesPlain from '../../../components/plain/plain.module.css';

import LabelField from '../../../components/plain/LabelField';
import FieldInteger from '../../../components/plain/FieldInteger';
import FieldString from '../../../components/plain/FieldString';
import FieldList_Enum from '../../../components/plain/FieldList_Enum';
import FieldList_Reference from '../../../components/plain/FieldList_Reference';

import { getDefinedValue } from '../../../util/tools';
import { CLASS_TOPIC } from '../../../util/consts/classes';
import { TOPIC_PATH } from '../../../util/routes';
import { FORM_TOPIC_TABLE } from '../../../util/consts/forms';
import { performApiRequest, QUERY_GETPAGE_API_URL } from '../../../util/restapi';

import iconAdd from '../../../assets/icons/png24x24/Add.png';

class TabAAPublications extends React.Component {

	refTopicNodes = [
		{
			classId: CLASS_TOPIC, plainFormPath: TOPIC_PATH, 
			selectInstanceFormId: FORM_TOPIC_TABLE,
			selectInstanceFormTitle: 'Теми'
		}
	];
	
	constructor(props) {
		super(props);
	}

	render() {
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.parentField;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{padding: '10px' }}>
				<div style={{display: 'flex'}}>
					<FieldList_Enum
						instance={instance} path={'publishing/status'} plain={plain}
						labelEmptyToHeader={true} readOnly={readOnly}
						styles={{divMain: {flexGrow: '1', marginRight: '20px'}}}
					/>
					<FieldList_Enum
						instance={instance} path={'publishing/language'} plain={plain}
						labelEmptyToHeader={true} readOnly={readOnly}
						styles={{divMain: {flexGrow: '1', marginRight: '20px'}}}
					/>
					<FieldList_Enum
						instance={instance} path={'publishing/audience'} plain={plain}
						labelEmptyToHeader={true} readOnly={readOnly}
						styles={{divMain: {flexGrow: '1'}}}
					/>
				</div>
				<div style={{display: 'flex'}}>
					<TopicList instance={instance} path={'publishing/genre'} plain={plain} 
						styles={{divMain: {marginTop: '10px', flexGrow: '1'}}}
						labelEmptyToHeader={true} readOnly={readOnly}
						refNodes={this.refTopicNodes}
					/>
				</div>
				<div style={{display: 'flex', alignItems: 'center', marginTop: '20px'}}>
					<FieldInteger instance={instance} path={'publishing/pubQty'} plain={plain}
						styles={{ input: {flexGrow: '0', width: '100px'} }} readOnly={readOnly}
					/>
				</div>
				<div style={{marginTop: '20px'}}>
					<LabelField instance={instance} path={'publishing/pubList'} />
					<FieldString instance={instance} path={'publishing/pubList'} plain={plain} readOnly={readOnly}
						multiline={true} rows={6} cols={60}
						styleInput={{width: '98%'}} ignoreTitle={true}
					 />
				</div>
			</div>
		);
	}
}

class TopicList extends FieldList_Reference {

	constructor(props) {
		super(props);
		this.state.serviceValue = '';
	}
	handleServiceValueChange = e => {
		this.setState({ serviceValue: e.target.value });
	};

	addTopics = async () => {
		let serviceValue = this.state.serviceValue; 
		if( serviceValue ) {
			let query = {
				queryId: 'topic_table',
				listColumn: [ {id: 'card'}, {id: 'topic_add'}, {id: 'topic_mod'}],
				listPredicate: [ { predicateId: 'code', conditionId: 'startsWith', value: serviceValue } ],
				listSorting: [	{ sortingId: 'cl_name', ascending: true } ],
				page: 1, pageSize: 15 
			};
			let filtersInitData = [
				{predicateId: 'code', value: serviceValue}
			];
			let response = await performApiRequest( QUERY_GETPAGE_API_URL, query );
			if( response.data.data.length == 1 ) {
				let rows = [ response.data.data[0].id ];
				this.onInstanceSelected( rows );
			} else {
				this.selectInstanceRvContext.filtersInitData = filtersInitData;
				this.setState({ isSelectInstanceModalOpen: true });
				let rateView = this.selectInstanceRvContext.rateView;
				rateView.updateData( response.data ); 
			}
			
		} else {
			this.setState({ isSelectInstanceModalOpen: true });
		}
	}
	
	createButtonAddHtml() {
		let readOnly = getDefinedValue( this.props.readOnly, false);
		let buttonAddHtml = (
			<div style={{display: 'flex', alignItems: 'center'}}>
				<input type='text' size='20' style={{height: '26px'}} 
					value={this.state.serviceValue} onChange={ this.handleServiceValueChange} 
				/>
				<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '5px', marginRight: '5px'}}
					onClick={this.addTopics} disabled={readOnly}
				>
					<img src={iconAdd} />
				</button>
			</div>
		);
		return buttonAddHtml;
	}
	
}

export default TabAAPublications;
